interface Target<V> {
  value: V;
}

interface Event {
  preventDefault: () => void;
  stopPropagation: () => void;
  [key: string]: any;
}

class SyntheticEventClass<V> {
  source?: Event;
  target: Target<V>;
  currentTarget: Target<V>;

  constructor(value: V, evt?: Event) {
    const target = {
      value,
    };
    this.target = target;
    this.currentTarget = target;
    this.source = evt;
  }

  preventDefault(): void {
    if (this.source) {
      this.source.preventDefault();
    }
  }

  stopPropagation() {
    if (this.source) {
      this.source.stopPropagation();
    }
  }
}

export function syntheticEvent<V>(
  value: V,
  evt?: Event
): SyntheticEventClass<V> {
  return new SyntheticEventClass(value, evt);
}

export type SyntheticEvent<V> = SyntheticEventClass<V>;
export type SyntheticEventType<V> = SyntheticEventClass<V>;
